<template>
  <resource-edit-wrapper
    :title="$t('resources.popups.edit_popup')"
    :need-modal="showModal"
    :show-bottom-actions="true"
    @saveAction="$refs['popupForm'].submit()">
    <PopupForm is-edit :popup="item" @isDirtyForm="isDirtyForm" ref="popupForm"></PopupForm>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import PopupForm from "@/components/forms/PopupForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    props: {
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    mixins: [resourceCreateAndEditActions],
    components: {
      ResourceEditWrapper,
      PopupForm,
    },
    created() {
      this.$admin.toast.info(this.$t("generic.edit_warning.warning") + this.$t("generic.edit_warning.pop-up"));
    },
  };
</script>
